import {User} from './user';
import {Locale} from './locale';
import {Program} from './program';
import {BulkEditSession} from './bulk-edit-session';

export interface AuditBulkEditTemplateComponentContentJSON {
  audit_bulk_edit_tcc_id: number;
  start_datetime: string;
  end_datetime: string;
  user_id: string;
  locale: string;
  product_id: string;
  filename: string;
  username?: string,
  productName?: string
  oldContent?: string,
  newContent?: string
}

export class AuditBulkEditTemplateComponentContent {

  static parse(json: AuditBulkEditTemplateComponentContentJSON): AuditBulkEditTemplateComponentContent {
    return new AuditBulkEditTemplateComponentContent(
      json.audit_bulk_edit_tcc_id,
      json.start_datetime ? new Date(Date.parse(json.start_datetime)) : undefined,
      json.end_datetime ? new Date(Date.parse(json.end_datetime)) : undefined,
      json.user_id,
      json.locale,
      json.product_id,
      json.filename,
      json.username,
      json.productName,
      json.oldContent,
      json.newContent
    );
  }

  static create(bes: BulkEditSession, user: User) {
    return new AuditBulkEditTemplateComponentContent(
      undefined,
      undefined,
      undefined,
      user.userId,
      bes.locale.localeName,
      bes.product.id,
      bes.file.name,
      user.username,
      bes.product.displayLabel);
  }

  constructor(
    public id: number,
    public start: Date,
    public end: Date,
    public userId: string,
    public locale: string,
    public product: string,
    public filename: string,
    public username?: string,
    public productName?: string,
    public oldContent?: string,
    public newContent?: string
  ) {
  }

  toJSON() {
    const obj = {};
    for (const prop in this) {
      switch (prop) {
        case 'id':
          obj['audit_bulk_edit_tcc_id'] = this[prop];
          break;
        case 'start':
        case 'end':
          obj[prop + '_datetime'] = ( isNaN(+this[prop]) || +this[prop] <= 0) ? this[prop] : (<any>this[prop]).toISOString();
          break;
        case 'userId':
          obj['user_id'] = this[prop];
          break;
        case 'product':
          obj['product_id'] = this[prop];
          break;
        default:
          obj[prop.toString()] = this[prop];
          break;
      }
    }
    return obj;
  }
}
